import React from 'react';
import IconSvg, { IconSvgProps } from './IconSvg';

const KeyboardArrowUp = (props: IconSvgProps) => (
  <IconSvg {...props}>
    <path d="M7.41 15.41 12 10.83l4.59 4.58L18 14l-6-6-6 6z" />
  </IconSvg>
);

export default KeyboardArrowUp;
